import React, { Component } from 'react'
import moment from 'moment'
import { translate } from 'react-i18next'
import { compose } from 'react-apollo'

class SummaryModal extends Component {
  render() {
    const { modalClose, order, t } = this.props

    return (
      <div>
        <i className="modal-close" onClick={modalClose} />

        <div className="modal-body">
          <h3>{t('summary')}</h3>

          <h4>
            {order.numDays} days in{' '}
            {order.planLocations.map((location, index) => {
              if (index !== order.planLocations.length - 1) return location.country + ', '
              else return location.country
            })}
          </h4>

          <div className="items">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">{t('total_payment')}</div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">${order.totalAmount}</div>
            </div>
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">{t('additional_services')}</div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">{order.servicesTotal ? '$' + order.servicesTotal : '$' + 0}</div>
            </div>
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">{t('group_type')}</div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">{order.travelingType}</div>
            </div>
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">{t('start_date')}</div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                {order.startDate
                  ? this.props.i18n.t('date_format', {
                      date: order.startDate
                    })
                  : ''}
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">{t('end_date')}</div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                {order.endDate
                  ? this.props.i18n.t('date_format', {
                      date: order.endDate
                    })
                  : ''}
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">{t('number_people')}</div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">{order.partySize || order.travelers.length + 1}</div>
            </div>
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">{t('trip_tempo')}</div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">{order.tripTempo}</div>
            </div>
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">{t('budget_person')}</div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">{`$${order.requestedBudgetMin} - $${order.requestedBudgetMax}`}</div>
            </div>
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">{t('activities')}</div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                {order.categories && order.categories.map((category, index) => {
                  if (index !== order.categories.length - 1) return t(category) + ', '
                  else return t(category)
                })}
              </div>
            </div>
          </div>

          <div className="comments">{order.comments}</div>
          <div className="modal-footer">
            <button type="button" className="btn order-action" onClick={modalClose}>
              {t('button_close')}
            </button>
          </div>
        </div>
      </div>
    )
  }
}

const enhance = compose(translate('orders'))
export default enhance(SummaryModal)



// WEBPACK FOOTER //
// src/components/Guru/Orders/Modals/SummaryModal.jsx